(function () {
  'use strict';

  var sectionId =
    'shopify-section-template--30532063133777__collection_list_EHPaRF';

  function initialise(scope) {
    var section = document.getElementById(sectionId);

    if (!section && scope && scope.querySelector) {
      section = scope.querySelector('.collection-list');
      if (section) {
        section = section.closest('.shopify-section') || section;
      }
    }

    if (!section || section.getAttribute('data-abtq-ready') === 'true') {
      return;
    }

    var grid = section.querySelector('.collection-list__container');
    if (!grid) {
      return;
    }

    var cards = [];
    var children = grid.children;
    var i;

    for (i = 0; i < children.length; i += 1) {
      if (children[i].classList.contains('collection-list__col')) {
        cards.push(children[i]);
      }
    }

    if (cards.length <= 8) {
      return;
    }

    section.setAttribute('data-abtq-ready', 'true');
    section.classList.add('abtq-categories-ready');

    if (!grid.id) {
      grid.id = 'abtq-home-category-grid';
    }

    var holder = document.createElement('div');
    holder.className = 'abtq-categories-toggle-wrap';

    var button = document.createElement('button');
    button.className = 'abtq-categories-toggle';
    button.type = 'button';
    button.setAttribute('aria-controls', grid.id);
    button.setAttribute('aria-expanded', 'false');
    button.textContent = 'Show all ' + cards.length + ' categories';

    function setExpanded(expanded) {
      if (expanded) {
        section.classList.add('abtq-categories-expanded');
      } else {
        section.classList.remove('abtq-categories-expanded');
      }

      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded
        ? 'Show fewer categories'
        : 'Show all ' + cards.length + ' categories';

      for (i = 8; i < cards.length; i += 1) {
        if (expanded) {
          cards[i].removeAttribute('aria-hidden');
        } else {
          cards[i].setAttribute('aria-hidden', 'true');
        }
      }
    }

    button.addEventListener('click', function () {
      setExpanded(button.getAttribute('aria-expanded') !== 'true');
    });

    holder.appendChild(button);
    grid.parentNode.insertBefore(holder, grid.nextSibling);
    setExpanded(false);
  }

  function start() {
    initialise(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target);
  });
}());